import React  from 'react';
import {
  Button,
  ModalDialog,
}             from '@components/index';
import styled from 'styled-components';

interface IProps {
  open      : boolean;
  onCancel  : () => void;
  onConfirm : () => Promise<void>;
}

const ButtonWrapper = styled.div`
  width           : 100%;
  display         : flex;
  justify-content : space-evenly;
`;

const WARNING_TEXT = `
The information on this page has not been saved yet.
If you logout now you’ll lose all that information.

Are you sure you want to logout?`;

export const LogoutWarningModal: React.FC<IProps> = ({
  open,
  onCancel,
  onConfirm,
}) => (
  <ModalDialog
    open      = {open}
    content   = {WARNING_TEXT}
    onClose   = {onCancel}
    fontSize  = "18px"
    textAlign = "center"
    textColor = "secondary"
    padding   = "50px 30px 15px"
    actions   = {(
      <ButtonWrapper>
        <Button
          label   = "Cancel"
          variant = "outlined"
          width   = "200px"
          size    = "large"
          onClick = {onCancel}
        />
        <Button
          label   = "Yes, Logout"
          width   = "200px"
          size    = "large"
          onClick = {onConfirm}
        />
      </ButtonWrapper>
    )}
  />
);
